import { Injectable } from '@angular/core';
import { AuthenticationService } from '@services/authentication.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { NotificationsService } from 'angular2-notifications';
import {
  interval, Subject,
  Subscription
} from 'rxjs';
import {
  distinctUntilChanged, share
} from 'rxjs/operators';
import { WebSocketSubject } from 'rxjs/webSocket';
import { WebsocketConnectionService } from './websocket-connection.service';
@Injectable({
  providedIn: 'root'
})
export class WebfeederScktService {

  url?: string;

  private connection?: WebSocketSubject<any> | null;
  private connectionSubs: Subscription | undefined;

  private _queueSub?: Subscription;
  private _queueMessages: any[] = []

  public subject: Subject<any> = new Subject();

  private _reconnectionAttempts = 0;
  private _maxReconnectionAttempts = 0;
  private _isReconnection = false;
  private _timeoutToReconnection = 1000;
  private _connectionChecked = false;

  subscriptions: Array<Subscription> = [];

  constructor(
    public wsConnectionSvc: WebsocketConnectionService,
    private _configService: ConfigService,
    private _authSvc: AuthenticationService,
    private notificationService: NotificationsService,
  ) {
    this.startConnection()
  }


  private async getUrl(): Promise<string> {
    let customToken = this._configService.getTokenGraphic();
    let baseUrl =  this._configService.getUrlWebSocketWebFeeder(this._reconnectionAttempts, true, customToken);
    // let baseUrl = environment.API_URLS.WEBFEEDER_WS_URL + '?reconnect=' + this._configService.getTokenWF(WebfeederScktService.name)
    let queryToken = '';
    return this.url = baseUrl + queryToken;
  }

  async getConnection(): Promise<WebSocketSubject<any> | null> {
    return this.startConnection();
  }

  private async startConnection(): Promise<WebSocketSubject<any> | null> {
    let url = await this.getUrl();
    return await this.createConnection(url);
  }

  async createConnection(url: string): Promise<WebSocketSubject<any> | null> {

    if (this.connection) {
      return this.connection;
    }

    this.connection = this.wsConnectionSvc.getConnection(url);

    if (!!!this.connection) {
      this.connection = this.wsConnectionSvc.createConnection(
        url,
        {
          next: (event) => {
            this._reconnectionAttempts = 0;
            if (this._isReconnection) {
              //TODO: Do in reconetion execution
            }

            if (!this._connectionChecked) {
              setTimeout(() => {
                this._connectionChecked = true;
                this.initQueue()
              }, 100);
            }

          }
        },
        {
          next: (event: CloseEvent) => {
            this.wsConnectionSvc.removeConnection(url);

            //TODO: Implements check cases to not reconnect
            // if([].includes(event.code)){
            //   return
            // }

            if (this._reconnectionAttempts <= this._maxReconnectionAttempts) {

              setTimeout(() => {
                this._reconnectionAttempts++;
                this.createConnection(url);
                this._isReconnection = true;
              }, this._timeoutToReconnection);

            } else {
              this._isReconnection = false;
            }
          }
        },
      );
    }

    if (this.connectionSubs) {
      this.connectionSubs.unsubscribe()
    }
    this.connectionSubs = this.connection?.pipe(
      distinctUntilChanged(),
      share()
    ).subscribe(
      {
        next: (event) => {
          if (event) {
            this.subject.next(event)
          }
        },
        error: (error) => { }
      }
    )

    this._isReconnection = false;
    return this.connection;
  }

  resetState() {
    this._reconnectionAttempts = 0;
    this.connection = null;
  }

  initQueue() {
    this._queueSub = interval(500).subscribe(
      () => {
        if (this._queueMessages.length > 0) {
          let msg = this._queueMessages.shift();
          this.sendMsg(msg);
        }

        if (this._queueMessages.length <= 0) {
          this._queueSub?.unsubscribe()
        }
      }
    )
  }

  async sendMsg(msg: any) {
    if (this._connectionChecked) {
      (await this.getConnection())?.next(msg);
    } else {
      this._queueMessages.push(msg);
    }
  }
}
